import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $11d41e46bc5e395d$exports = {};
$11d41e46bc5e395d$exports = import.meta.resolve("oCJ0R");


// start-snippet{displaymode.fillcontainer}
const $e822f006b53d7337$var$game = new $6TXE3.Engine({
    canvasElementId: 'game',
    displayMode: $6TXE3.DisplayMode.FillContainer // highlight-line
});
// end-snippet{displaymode.fillcontainer}
const $e822f006b53d7337$var$playerImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($11d41e46bc5e395d$exports))));
const $e822f006b53d7337$var$loader = new $6TXE3.Loader([
    $e822f006b53d7337$var$playerImage
]);
$e822f006b53d7337$var$game.start($e822f006b53d7337$var$loader).then(()=>{
    const actor = new $6TXE3.Actor({
        pos: $e822f006b53d7337$var$game.screen.center
    });
    actor.graphics.use($e822f006b53d7337$var$playerImage.toSprite());
    $e822f006b53d7337$var$game.currentScene.add(actor);
});


//# sourceMappingURL=fillcontainer.a57091ec.js.map
